const initialState = {}

export default (state = initialState, action) => {
	switch (action.type){
        case 'ADD_ROUTE':
            return {
                ...action.route
            }
		default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/store/reducers/route.js